
import About from './About';
import './App.css';
import Contact from './Contact';
import Experience from './Experience';
import Footer from './Footer';
import Home from './Home';
import Navbar from './Navbar';
import Project from './Project';
import Skills from './Skills';

function App() {
  return (
    <>

<Navbar />
<Home />
<About />
<Skills />
<Experience />
<Project />
<Contact />
  <Footer />
    </>
  );
}

export default App;
